import React from 'react'
import Modal from 'react-responsive-modal'
import moment from 'moment'
import { IoMdClose } from 'react-icons/io'
import { joinValues, uniqueValues, themeNumber, pairTitle, pairTime } from './buildWeek'
import styles from './styles.module.css'

/* Окно пары — только просмотр: полный состав пары, ни одной кнопки, изменяющей
   данные (п. 6.8 ТЗ). Закрытие по кнопке, крестику, подложке и Esc, блокировка
   прокрутки с компенсацией полосы — на стороне react-responsive-modal. */

const Value = ({ value }) => (value
  ? <div className={styles.modalValue}>{value}</div>
  : <div className={`${styles.modalValue} ${styles.dash}`}>—</div>)

const Tiles = ({ items }) => (items.length
  ? (
    <div className={styles.tiles}>
      {items.map(item => <span key={item}>{item}</span>)}
    </div>
  )
  : <div className={`${styles.modalValue} ${styles.dash}`}>—</div>)

const Field = ({ label, wide, children }) => (
  <div className={wide ? styles.wide : undefined}>
    <span className={styles.modalLabel}>{label}</span>
    {children}
  </div>
)

const LessonModal = ({ pair, onClose }) => {
  const lessons = pair ? pair.lessons : []
  const disciplines = joinValues(lessons, lesson => lesson.course_name)
  const groups = uniqueValues(lessons, lesson => lesson.group_name)
  const rooms = uniqueValues(lessons, lesson => lesson.room_names || lesson.room_name)

  return (
    <Modal
      open={Boolean(pair)}
      onClose={onClose}
      center
      showCloseIcon={false}
      reserveScrollBarGap
      classNames={{ modal: styles.modal }}
    >
      {pair && (
        <>
          <div className={styles.modalHead}>
            <button
              type="button"
              className={styles.modalClose}
              onClick={onClose}
              title="Закрыть"
              aria-label="Закрыть"
            >
              <IoMdClose size={18} />
            </button>
            <div className={styles.modalTitle}>{disciplines || '—'}</div>
            <div className={styles.modalSub}>
              {`${pair.weekdayName}, ${moment(pair.date, 'YYYY-MM-DD').format('DD.MM.YYYY')}`}
              {` · ${pairTitle(pair)}`}
              {pairTime(pair) && ` · ${pairTime(pair)}`}
            </div>
          </div>

          <div className={styles.modalBody}>
            <div className={styles.modalGrid}>
              <Field label="Дисциплина" wide>
                <Value value={disciplines} />
              </Field>
              <Field label="Вид занятия">
                <Value value={joinValues(lessons, lesson => lesson.lesson_type_name)} />
              </Field>
              <Field label="Номер темы/занятия">
                <Value value={joinValues(lessons, themeNumber)} />
              </Field>
              <Field label="Учебные группы" wide>
                <Tiles items={groups} />
              </Field>
              <Field label="Аудитории" wide>
                <Tiles items={rooms} />
              </Field>
            </div>
          </div>

          <div className={styles.modalFoot}>
            <span className={styles.modalNote}>
              Расписание составляется в десктопной программе
            </span>
            <button type="button" className={styles.modalCloseBtn} onClick={onClose}>
              Закрыть
            </button>
          </div>
        </>
      )}
    </Modal>
  )
}

export default LessonModal
